import type { MetadataFotovoltaicoDTO } from '@/models/dto/fotovoltaico/metadata-fotovoltaico-dto'
import type { PhotovoltaicPropertyData } from '@/models/types/photovoltaic/photovoltaic-property-data'

function mapToMetadataFotovoltaicoDTO(data: PhotovoltaicPropertyData): MetadataFotovoltaicoDTO {
    return {
        id: data.id,
        key: data.key,
        type: data.type,
        value: data.value ?? null,
    }
}

function mapToPhotovoltaicPropertyData(dto: MetadataFotovoltaicoDTO): PhotovoltaicPropertyData {
    return {
        id: dto.id,
        key: dto.key,
        type: dto.type,
        value: dto.value ?? undefined,
    }
}

export { mapToMetadataFotovoltaicoDTO, mapToPhotovoltaicPropertyData }
